import { render } from "./CandidateAutocomplete.vue?vue&type=template&id=6f64b287&scoped=true"
import script from "./CandidateAutocomplete.vue?vue&type=script&lang=js"
export * from "./CandidateAutocomplete.vue?vue&type=script&lang=js"

import "./CandidateAutocomplete.vue?vue&type=style&index=0&id=6f64b287&scoped=true&lang=css"

import exportComponent from "/home/user/AIF_Orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f64b287"]])

export default __exports__